'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'rainbow';
var width = 640;
var height = 512;
var aliases = [127752];
var unicode = 'f75b';
var svgPathData = ['M48 360C48 209.8 169.8 88 320 88s272 121.8 272 272l0 96 0 24-64 0 0-24 0-96c0-106.8-80.4-194.7-184-206.6l0-1.4-24 0c-114.9 0-208 93.1-208 208l0 96 0 24-64 0 0-24 0-96zm112 0c0-88.4 71.6-160 160-160s160 71.6 160 160l0 96 0 24-64 0 0-24 0-96c0-44.7-30.6-82.3-72-93l0-3-24 0c-53 0-96 43-96 96l0 96 0 24-64 0 0-24 0-96z', 'M320 88C169.8 88 48 209.8 48 360l0 96 0 24L0 480l0-24 0-96C0 183.3 143.3 40 320 40l24 0 0 .9C509.5 53.2 640 191.3 640 360l0 96 0 24-48 0 0-24 0-96C592 209.8 470.2 88 320 88zm0 224c-26.5 0-48 21.5-48 48l0 96 0 24-48 0 0-24 0-96c0-53 43-96 96-96l24 0 0 3c41.4 10.7 72 48.2 72 93l0 96 0 24-48 0 0-24 0-96c0-26.5-21.5-48-48-48zM160 360l0 96 0 24-48 0 0-24 0-96c0-114.9 93.1-208 208-208l24 0 0 1.4C447.6 165.3 528 253.2 528 360l0 96 0 24-48 0 0-24 0-96c0-88.4-71.6-160-160-160s-160 71.6-160 160z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;